import { Resolver, Subscription, Root, Arg } from 'type-graphql'
import { filter, pipe } from 'graphql-yoga'
import { pubsub } from '@things-factory/shell'
import { PlayGroup } from './play-group.js'

@Resolver(PlayGroup)
export class PlayGroupSubscription {
  @Subscription({
    description: 'Subscribes to real-time updates for a specific play group.',
    subscribe: ({ args, context, info }) => {
      const { domain, user } = context.state
      const { id } = args
      const subdomain = domain?.subdomain

      if (!domain) {
        throw new Error('domain required')
      }

      if (!user.domains?.find(d => d.subdomain === subdomain) && !process.superUserGranted(domain, user)) {
        throw new Error(`domain(${subdomain}) is not working for user(${user.email}).`)
      }

      return pipe(
        pubsub.subscribe('play-group'),
        filter((payload: { playGroup: PlayGroup }) => {
          const { id: playGroupId, domainId } = payload.playGroup

          if (domainId !== domain.id) {
            return false
          }

          if (id !== playGroupId) {
            return false
          }

          return true
        })
      )
    }
  })
  playGroup(@Root() payload: { playGroup: PlayGroup }, @Arg('id') id: string): PlayGroup {
    return payload.playGroup
  }
}
